import React from 'react';
import { FormField } from 'taboola-ultimate-ui';
import { OutlineEditableText } from 'modules/campaigns/components/OutlineEditableText/OutlineEditableText';
import { withIndication } from 'modules/errors';
import { FormattedMessage, useIntl } from 'modules/taboola-common-frontend-modules/i18n';
import { useFormValidatedValue, validationFunctions } from 'modules/taboola-common-frontend-modules/validations';
import styles from './subscriptionPolicyIdField.module.scss';

const OutlineEditableTextWithIndication = withIndication(OutlineEditableText);
const validations = [
    {
        validationFn: validationFunctions.isNotEmptyString,
        messageId: 'push-api.subscription.validations.error.policyId.empty',
        defaultMessage: 'Please enter a Policy ID',
    },
];

export const SubscriptionPolicyIdField = () => {
    const {
        value: policyId,
        onChange: onPolicyIdChange,
        indicationData,
    } = useFormValidatedValue({
        field: 'policyId',
        validations,
    });

    const { formatMessage } = useIntl();
    const placeholder = formatMessage({
        id: `push-api.subscription.policyId.placeholder`,
        defaultMessage: 'Type policy id here...',
    });

    return (
        <FormField
            inputId="subscription-policyId-input"
            containerClass={styles['input-container']}
            label={<FormattedMessage id="push-api.subscription.policyId.title" defaultMessage="Policy ID" />}
        >
            <OutlineEditableTextWithIndication
                id="policyId"
                value={policyId}
                onChange={onPolicyIdChange}
                placeholder={placeholder}
                {...indicationData}
            />
        </FormField>
    );
};
